<template>
  <div>
    <template v-if="min_resolution !== null">
      <div class="input-group">
        <label>{{ 'feelgrid:puredata.resolution.label' | trans }}</label>
        <select v-model="r" class="form-control">
          <option :value=false>
            {{ 'feelgrid:puredata.resolution.auto' | trans }}
          </option>
          <option v-for="(t, name) in resolutions" :value=t>
            {{ 'feelgrid:puredata.resolution.' + name | trans }}
          </option>
        </select>
      </div>
    </template>
    <div class="input-group">
      <label>{{ 'feelgrid:puredata.time_interval.label' | trans }}</label>
      <select v-model="v" class="form-control">
        <option v-for="i in time_intervals" :value=i>
          {{ 'feelgrid:puredata.time_interval.' + i | trans }}
        </option>
      </select>
    </div>
    <button type="button"
      v-if=reload
      class="btn lg"
      @click="$emit('reload')"
      :title="$t('feelgrid:puredata.reload_limit')"
    >
      {{ 'buttons.reload' | trans }}
    </button>
  </div>
</template>

<script>
  import _ from 'lodash';
  import {time_intervals} from '../mixins'

  export default {
    name: 'IntervalSelector',
    props: {
      value: {required: true,},
      reload: {default: true,},
      resolution: {default: false,},
      min_resolution: {default: null,},
    },
    data () {return {
      time_intervals,
    }},
    computed: {
      v: {
        get () {
          return this.value;
        },
        set (v) {
          this.$emit('input', v);
        },
      },
      r: {
        get () {
          return this.resolution;
        },
        set (v) {
          this.$emit('resolution', v);
        },
      },
      resolutions () {
        var all = {
          '1min': 60,
          '10min': 600,
          '30min': 1800,
          '1h': 3600,
          '6h': 6 * 3600,
          '1d': 24 * 3600,
        };
        if (this.min_resolution) {
          return _.pickBy(all, v => {
            if (v < this.min_resolution) {
              return false;
            }
            if (v / this.min_resolution > 20) {//to prevent too many API requests
              return false;
            }
            return true;
          });
        }
        return {};
      },
    },
  }
</script>


// WEBPACK FOOTER //
// src/apps/feelgrid/assets/IntervalSelector.vue